import React, { FC, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import {
  Container,
  TopInfoWrapper,

} from '../../../pools/styles'
import { Button, ModalVariables, Table, TopProgress } from '../../../../../../../components'
import { icons } from '../../../../../../../icons'
import { useNavigate, useParams } from 'react-router-dom'
import { loadBalancerService, networkService } from '../../../../../../../api'
import { useQueryParam, StringParam, NumberParam } from 'use-query-params';
import { useUi } from '../../../../../../../context/ui.context'
import { handleStatusName } from '../../../../../../../utils/handle-status-name'
import { StateWrapper, GreenDot, Greentext } from '../../../../../Instances/styles'
import { useAuth } from '../../../../../../../context/user.context'

const Policies:FC = () => {
  const [t] = useTranslation()
  const {lbId, listenerId, policyId} = useParams()
  const {viewAlert} = useUi()
  const navigate = useNavigate()
  const {user} = useAuth()
  const [pageLoading, setPageLoading] = useState<boolean>(true)
  const [loading, setLoading] = useState<boolean>(false)
  const [rules, setRules] = useState<any[]>([])
  const [viewModal, setViewModal] = useState<boolean>(false)
  const [activeAnimation, setActiveAnimation] = useState<boolean>(false)
  const [modalType, setModalType] = useState<any>('')
  const [alertTitle, setAlertTitle] = useState<any>()
  const [alertSubTitle, setAlertSubTitle] = useState<any>()

  const [allChecked, setAllChecked] = useState<boolean>(false)
  const [checked, setChecked] = useState<any[]>([])
  const [deletedRule, setDeletedRule] = useState<any>()


  const editChecked = (item:any) => {
    const founded = checked.find((ckd:any) => ckd.id === item?.id)
    if(allChecked){
      setAllChecked(!allChecked)
    }
    if(founded) {
      setChecked((prev:any) => {
        return prev.filter((ckd:any) => ckd.id !== item?.id)
      })
    } else {
      setChecked([...checked, item])
    }
  }
  const _updateRules = () => {
    //@ts-ignore
    loadBalancerService.getPolicyRules(policyId)
    .then((res) => {
      setRules(res.data.objects.map((rule:any) => {
        return{
          ...rule,
          key:rule.key || 'n/a',
          name:rule.type,
          admin_state_up:rule.admin_state_up ? 'Yes' : 'No',
          navigate:`/openstack/load-balancer-listener/${lbId}/${listenerId}/policies/${policyId}/rules/${rule.id}`,
          invert:rule.invert ? 'Yes' : 'No',
          operating_status: 
            (<StateWrapper>
              <GreenDot active={rule.operating_status}/>
              <Greentext active={rule.operating_status}>
                {handleStatusName(rule.operating_status, t)}
              </Greentext>
            </StateWrapper>),
          provisioning_status: 
            (<StateWrapper>
              <GreenDot active={rule.provisioning_status}/>
              <Greentext active={rule.provisioning_status}>
                {handleStatusName(rule.provisioning_status, t)}
              </Greentext>
            </StateWrapper>),
        }
      }))
      setPageLoading(false)
      setLoading(false)
    })
  }
  const deleteRule = async () => {
    if(!policyId) return
    setLoading(true)
    try{
      await loadBalancerService.deleteRule(deletedRule.id, policyId)
      await viewAlert({
        severity:'info',
        message:`${t("RULE_DELETED_SUCCESS")}`
      })
      await _updateRules()
    } catch (e:any) {
      if(e?.response?.data.detail){
        viewAlert({
          severity:'error',
          message:e.response.data.detail,
        })
      }
      _updateRules()
      setPageLoading(false)
      setLoading(false)
    } finally {
      setViewModal(false)
      setActiveAnimation(false)
    }
  }
  useEffect(() => {
    _updateRules()
    const interval = setInterval(() => {
      _updateRules()
    },10000)
    return () => clearInterval(interval)
  },[])
  const openModal = (modal:any) => {
    setModalType(modal)
    setViewModal(true)
    setActiveAnimation(true)
  }
  const closeModal = (props:any) => {
    deleteRule()
  }
  const closeModalCancel = () => {
    setViewModal(false)
    setActiveAnimation(false)
  }
  const items = [
    {
      title:t("EDIT"),
      id:'2',
      icon:icons.Edit,
      onClick: (rule:any) => navigate(`${rule.id}/edit`),
      divider:false
    },
    {
      title:t("DELETE"),
      id:'4',
      onClick:(id:any) => {
        openModal('delete')
        setAlertTitle(t("RULE"))
        setAlertSubTitle([id])
        setDeletedRule(id)
      },
      icon:icons.DeleteIcon,
      divider:false
    },
  ]
  const Columns = [
    {
      title:t("TYPE"),
      key:'name'
    },
    {
      title:t("KEY"),
      key:'key',
    },
    {
      title:t("VALUE"),
      key:'value'
    },
    {
      title:t("INVERT"),
      key:'invert'
    },
    {
      title:t("OPERATING_STATUS"),
      key:'operating_status'
    },
    {
      title:t("PROVISIONING_STATUS"),
      key:'provisioning_status'
    },
    {
      title:t("COMPARE_TYPE"),
      key:'compare_type'
    },
    {
      title:t("ADMIN_STATE_UP"),
      key:'admin_state_up'
    },
    {
      title:'',
      key:'props'
    },
  ]
  if(pageLoading) return <TopProgress loading={pageLoading}/>
  return(
    <Container>
      <TopProgress loading={loading}/>
      <TopInfoWrapper>
        <div style={{display:'flex', marginBottom:'20px'}}>
          <Button
            variant="primary"
            size="display"
            onClick={() => navigate(`create`)}
            title={t("CREATE_NEW_POLICY_RULE")}
            customStyles={{marginRight:'10px'}}
          />
        </div>
      </TopInfoWrapper>
        <Table
          columns={Columns}
          rows={rules}
          settings={items}
          allChecked={allChecked}
          setAllChecked={setAllChecked}
          checked={checked}
          setChecked={editChecked}
          hideOther
          hideCheckbox
        />
      <ModalVariables
        modalType={modalType}
        viewModal={viewModal}
        activeAnimation={activeAnimation}
        closeModal={closeModal}
        closeModalCancel={closeModalCancel}
        alertTitle={alertTitle}
        alertSubTitle={alertSubTitle}
        // dataToEdit={editedSubnet}
        loading={loading}
      />
    </Container>
  )
}
export default Policies
